import Fetcher from './fetch'
import * as routes from './routes'

const userFetcher = new Fetcher(routes.userEndpoint)

export const requestLogin = data => userFetcher.post(routes.loginRoute, data)
export const requestVendorLogin = data =>
  userFetcher.post(routes.vendorLoginRoute, data)
export const requestRefreshToken = data =>
  userFetcher.put(routes.loginRoute, data)

const guestFetcher = new Fetcher(routes.guestEndpoint)

export const requestSendSMS = payload =>
  guestFetcher.post(routes.sendSMSRoute, payload)
export const requestConfirmSMS = payload =>
  guestFetcher.put(routes.confirmSMSRoute, payload)

const memberFetcher = new Fetcher(routes.userEndpoint, true)

export const requestLogout = () => memberFetcher.delete(routes.loginRoute)

const slashFetcher = new Fetcher(routes.slashEndpoint, true)

export const requestCreateCreamItem = payload => slashFetcher.post('', payload) // 開啟團購項目
export const requestTerminateCreamItem = itemId =>
  slashFetcher.delete(routes.terminateCreamItemRoute(itemId)) // 關閉團購項目
export const requestGetSlashInfo = () =>
  slashFetcher.get(routes.getSlashInfoRoute) // 取得開團頁面資訊

export const requestGetSellerHistories = timestampTz =>
  slashFetcher.get(routes.sellerHistoriesRoute(timestampTz)) // 取得開團紀錄
export const requestGetSellerHistoryDetail = (itemId, timestampTz) =>
  slashFetcher.get(routes.sellerHistoryDetailRoute(itemId, timestampTz)) // 取得開團明細
export const requestGetInstalmentHistories = periodId =>
  slashFetcher.get(routes.instalmentHistoriesRoute(periodId)) // 取得分期紀錄
export const requestGetInflowHistories = timestampTz =>
  slashFetcher.get(routes.inflowHistoriesRoute(timestampTz)) // 取得收款紀錄
export const requestGetOutflowHistories = timestampTz =>
  slashFetcher.get(routes.outflowHistoriesRoute(timestampTz)) // 取得付款 / 提領紀錄
export const requestGetInflowHistoryDetail = transactionId =>
  slashFetcher.get(routes.inflowHistoryDetailRoute(transactionId)) // 取得收款紀錄詳細資訊
export const requestGetOutflowPaymentDetail = transactionId =>
  slashFetcher.get(routes.outflowPaymentDetailRoute(transactionId)) // 取得付款紀錄詳細資訊
export const requestGetOutflowWithdrawDetail = withdrawId =>
  slashFetcher.get(routes.outflowWithdrawDetailRoute(withdrawId)) // 取得提領紀錄詳細資訊
export const requestWithdrawInfo = amount =>
  slashFetcher.get(routes.withdrawInfoRoute(amount)) // 取得實際提領金額相關資訊
export const requestCreateWithdraw = payload =>
  slashFetcher.post(routes.createWithdrawRoute, payload) // 申請提領`

const slashPublicFetcher = new Fetcher(routes.slashEndpoint)
export const requestGetItemEntryInfo = itemId =>
  slashPublicFetcher.get(routes.itemEntryInfoRoute(itemId)) // 取得購買連結資訊
export const requestGetBuyerInstalmentsInfo = periodId =>
  slashPublicFetcher.get(routes.buyerInstalmentsInfoRoute(periodId)) // 取得逾期款項付款資訊
export const requestGetBuyerPeriodicInfo = orderNo =>
  slashPublicFetcher.get(routes.buyerPeriodicInfoRoute(orderNo)) // 取得逾期款項付款資訊

export const requestSendPurchasedBackupEmail = payload =>
  slashPublicFetcher.post(routes.sendPurchasedBackupEmailRoute, payload)
export const requestSendPurchasedEmailToSeller = payload =>
  slashPublicFetcher.post(routes.sendPurchasedEmailToSellerRoute, payload)

const paymentPublicFetcher = new Fetcher(routes.paymentEndpoint)

export const requestCreateTapPayOrder = payload =>
  paymentPublicFetcher.post(routes.createTapPayOrderRoute, payload)
export const requestCreateTapPayInstalment = payload =>
  paymentPublicFetcher.post(routes.createTapPayInstalmentRoute, payload) // 逾期款項付款
export const requestGetPaymentInfoGuest = itemId =>
  paymentPublicFetcher.get(routes.paymentInfoGuestRoute(itemId)) // 取得非會員付款頁面資訊
export const requestGetTapPayConfigGuest = payload =>
  paymentPublicFetcher.post(routes.tapPayConfigGuestRoute, payload)

export const requestCreateTapPayPeriodic = payload =>
  paymentPublicFetcher.post(routes.createTapPayPeriodicRoute, payload) //定期定額付款
const paymentPrivateFetcher = new Fetcher(routes.paymentEndpoint, true)

export const requestGetPaymentInfoMember = itemId =>
  paymentPrivateFetcher.get(routes.paymentInfoMemberRoute(itemId)) // 取得會員付款頁面資訊
export const requestGetTapPayConfigMember = memberQuery =>
  paymentPrivateFetcher.get(routes.tapPayConfigMemberRoute(memberQuery))

export const requestGetTransactionResult = (recTradeId, orderNo) => {
  return paymentPublicFetcher.get(routes.getPurchaseResult(recTradeId, orderNo))
} // 取得結果頁資訊
